import { Paths, PathValue } from "@mctypes/global.types";
import { Button, Paper, Stack, Title, Box, Flex } from "@mantine/core";
import { HSpace, McInputNew, McTextAreaNew } from "../../../../../../components";
import {
  IGKMaalingAvTrykkfallOverHepafilterResultater,
  IGKRapport,
} from "@mcapps/shared/reportSchemas/gkReportSchema";
import ReportDocxImageContainer from "../../../ReportBoard/ReportDocxImageContainer";
const MaalingAvTrykkfallOverHepaFilter: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKMaalingAvTrykkfallOverHepafilterResultater;
}> = ({ data, onUpdateEditData }) => {
  const addNewRow = () => {
    const newFilter = {
      filterNr: "",
      maaleresultat: null,
    };
    const updatedMaaleresultater = [...data.inndata.maaleresultater, newFilter];
    onUpdateEditData("testResultater.maalingAvTrykkfallOverHepafilter.inndata.maaleresultater", updatedMaaleresultater);
    return updatedMaaleresultater;
  };
  const removeLastRow = () => {
    const updatedMaaleresultater = [...data.inndata.maaleresultater];
    if (updatedMaaleresultater.length > 0) {
      updatedMaaleresultater.pop(); // Remove the last element
      onUpdateEditData(
        "testResultater.maalingAvTrykkfallOverHepafilter.inndata.maaleresultater",
        updatedMaaleresultater,
      );
    }
  };
  const updateMaaleresultater = (resultat: string | number, i: number, parameter: string) => {
    const maaleresultater = [...data.inndata.maaleresultater];
    maaleresultater[i][parameter] = resultat;
    onUpdateEditData("testResultater.maalingAvTrykkfallOverHepafilter.inndata.maaleresultater", maaleresultater);
  };
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>Måling av trykkfall over HEPA-filter</Title>
        <Stack gap={0}>
          <b>Hvor mange målinger skal utføres?:</b>
          <Flex>
            <Button color="green" onClick={addNewRow}>
              Legg til rad
            </Button>
            <HSpace />
            <Button variant="danger-filled" onClick={removeLastRow}>
              Fjern siste rad
            </Button>
          </Flex>
        </Stack>
        {data.inndata.maaleresultater.length > 0 && (
          <Flex direction="column" mt="lg" style={{ width: "50%" }}>
            <b>Fyll inn måleresultater:</b>
            <table>
              <thead>
                <tr>
                  <th>Filternummer &#40;-&#41;</th>
                  <th>Trykkfall &#40;Pa&#41;</th>
                </tr>
              </thead>
              {data.inndata.maaleresultater.map((filter, i) => (
                <tbody key={i}>
                  <tr>
                    <td>
                      <McInputNew
                        value={filter.filterNr}
                        type="text"
                        onChange={(e) => updateMaaleresultater(e.target.value, i, "filterNr")}
                        placeholder="Skriv inn filternummer"
                      />
                    </td>
                    <td>
                      <McInputNew
                        value={filter.maaleresultat}
                        normalizeNumbers={true}
                        type="text"
                        onBlur={(e) => updateMaaleresultater(Number(e.target.value), i, "maaleresultat")}
                        placeholder="Trykkfall"
                      />
                    </td>
                  </tr>
                </tbody>
              ))}
            </table>
          </Flex>
        )}
        <Box mt="lg">
          <ReportDocxImageContainer
            docxImageTag="maalingAvTrykkfallOverHepafilter"
            title="Nummerering av HEPA-filter"
          />
          <div style={{ width: "50%" }}>
            <McTextAreaNew
              label="Kommentar:"
              value={data.inndata.kommentar}
              onChange={(e) =>
                onUpdateEditData("testResultater.maalingAvTrykkfallOverHepafilter.inndata.kommentar", e.target.value)
              }
            />
          </div>
        </Box>
      </Stack>
    </Paper>
  );
};
export default MaalingAvTrykkfallOverHepaFilter;